/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Tax_Id_NfpInputs */

const en_label_tax_id_nfp = /** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charity Reg. Number`)
};

const es_label_tax_id_nfp = /** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de Registro de la ONG`)
};

const fr_label_tax_id_nfp = /** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro d'enregistrement de l'association`)
};

const de_label_tax_id_nfp = /** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinsregisternummer`)
};

const id_label_tax_id_nfp = /** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nomor Registrasi Yayasan`)
};

/** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */
const ja_label_tax_id_nfp = en_label_tax_id_nfp;

/** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */
const zh_label_tax_id_nfp = en_label_tax_id_nfp;

/** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */
const ar_label_tax_id_nfp = en_label_tax_id_nfp;

/** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */
const it_label_tax_id_nfp = en_label_tax_id_nfp;

/** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */
const ru_label_tax_id_nfp = en_label_tax_id_nfp;

/** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */
const pt_label_tax_id_nfp = en_label_tax_id_nfp;

/** @type {(inputs: Label_Tax_Id_NfpInputs) => LocalizedString} */
const ko_label_tax_id_nfp = en_label_tax_id_nfp;

/**
* | output |
* | --- |
* | "Charity Reg. Number" |
*
* @param {Label_Tax_Id_NfpInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_tax_id_nfp = /** @type {((inputs?: Label_Tax_Id_NfpInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Tax_Id_NfpInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_tax_id_nfp(inputs)
	if (locale === "es") return es_label_tax_id_nfp(inputs)
	if (locale === "fr") return fr_label_tax_id_nfp(inputs)
	if (locale === "de") return de_label_tax_id_nfp(inputs)
	if (locale === "ja") return ja_label_tax_id_nfp(inputs)
	if (locale === "zh") return zh_label_tax_id_nfp(inputs)
	if (locale === "ar") return ar_label_tax_id_nfp(inputs)
	if (locale === "id") return id_label_tax_id_nfp(inputs)
	if (locale === "it") return it_label_tax_id_nfp(inputs)
	if (locale === "ru") return ru_label_tax_id_nfp(inputs)
	if (locale === "pt") return pt_label_tax_id_nfp(inputs)
	return ko_label_tax_id_nfp(inputs)
});